// extracted by mini-css-extract-plugin
module.exports = {"container":"Expandable_container__11Z5n","expanded":"Expandable_expanded__3MiLe","content":"Expandable_content__1sqf9","collapsed":"Expandable_collapsed__2vb8C"};